/**
 * Petit client HTTP pour l'API. Chemins relatifs volontairement : le front et
 * l'API partagent la même origine (proxy Vite en dev, Nginx en production),
 * ce qui permet au cookie de session httpOnly d'accompagner chaque requête.
 */
async function request(path, { method = 'GET', body, ...options } = {}) {
  const response = await fetch(`/api${path}`, {
    method,
    credentials: 'same-origin',
    headers: body ? { 'Content-Type': 'application/json' } : undefined,
    body: body ? JSON.stringify(body) : undefined,
    ...options,
  });

  const payload = await response.json().catch(() => null);

  if (!response.ok) {
    throw new Error(payload?.error ?? `Erreur ${response.status}`);
  }

  return payload;
}

export const api = {
  get: (path, options) => request(path, { ...options, method: 'GET' }),
  post: (path, body, options) => request(path, { ...options, method: 'POST', body }),
  patch: (path, body, options) => request(path, { ...options, method: 'PATCH', body }),
  delete: (path, options) => request(path, { ...options, method: 'DELETE' }),
};
